import FeedContentDTO from "../dto/feed-content.dto";
import { ContentPriorityType } from "../enum/v2/content-priority-type";

export default {
  install: (app, options) => {
    const mapArticlePriorityToScore = (
      priority: ContentPriorityType
    ): number => {
      switch (priority) {
        case ContentPriorityType.LOW:
          return 1;
        case ContentPriorityType.MEDIUM:
          return 2;
        case ContentPriorityType.HIGH:
          return 3;
      }
    };

    const sortFeedContent = (
      feedContent: FeedContentDTO[]
    ): FeedContentDTO[] => {
      const withScores = feedContent.map((article) => {
        const score = getFinalSortScoreForArticle(article);
        return { ...article, finalSortScore: score };
      });

      return withScores.sort((a, b) => b.finalSortScore - a.finalSortScore);
    };

    const getFinalSortScoreForArticle = (article: FeedContentDTO): number => {
      const isFavoriteMalus = article.isFavorite ? 2 : 0;

      return (
        mapArticlePriorityToScore(article.priority) +
        article.relevanceScore -
        isFavoriteMalus
      );
    };

    app.provide("sortFeedContent", sortFeedContent);

    app.config.globalProperties.$feedManager = {
      sortFeedContent,
    };
  },
};
